import { Injectable } from '@angular/core';
import { Pagination } from '@lib/models/pagination.model';
import { Observable } from 'rxjs';
import { DemandeValidationPjStatutBackOffice } from '@lib/models/demande-validation-pj/types/demande-validation-pj-statut.type';
import { ValidationPjTabsCounters } from '../models/validation-pj-tabs-counters.model';
import { DemandeValidationPj } from '@lib/models/demande-validation-pj/demande-validation-pj.model';
import { PieceJustificativeDocumentType } from '@lib/models/demande-validation-pj/types/piece-justificative-document-types.type';

@Injectable()
export abstract class DemandeValidationPjBackOfficeService {
  public readonly aAffecterStatuts: DemandeValidationPjStatutBackOffice[] = [
    'a_affecter',
  ];

  public readonly aControlerStatuts: DemandeValidationPjStatutBackOffice[] = [
    'a_controler',
    'controle_en_cours',
    'nc_traitee',
  ];

  public readonly enAttenteStatuts: DemandeValidationPjStatutBackOffice[] = [
    'nc_a_traiter',
  ];

  public readonly enSignatureStatuts: DemandeValidationPjStatutBackOffice[] = [
    'en_signature',
    'relance',
  ];

  public readonly historiqueStatuts: DemandeValidationPjStatutBackOffice[] = [
    'expire',
    'valide',
    'refuse',
    'annule',
  ];

  abstract watchDemandesCountByCategories(): Observable<ValidationPjTabsCounters>;
  abstract getDemandeValidationPjs(
    search: string | null,
    statuts: DemandeValidationPjStatutBackOffice[],
    gestionnaireCodes: string[],
    pieceJustificativeTypes: PieceJustificativeDocumentType[],
    pageIndex: number,
    pageSize: number,
    sortField: 'dateDeclaration' | 'dateUpdate',
    sortOrder: 'asc' | 'desc'
  ): Promise<Pagination<DemandeValidationPj>>;
  abstract affecterDemandeValidationPj(
    publicIds: string[],
    gestionnaireId: string
  ): Promise<void>;
  abstract refuserDemandeValidationPj(
    publicId: string,
    commentaire: string
  ): Promise<void>;
  abstract relancerSignature(
    publicId: string,
    newEmail: string | null,
    useNewEmailAsDefault: boolean,
    newNumber: string | null,
    useNewNumberAsDefault: boolean
  ): Promise<void>;
}
